<ng-container *ngIf="isProjectTab; else dashboard">
  <div class="responsive-height">
    <div class="topspaces">
      <div class="dashboardtext welcome-msg-align" style="overflow: auto">
        <ng-container>
          <p class="welcometext">
            Welcome to your <span class="username username-hide-mobile">Packaging</span>
          </p>
          <p class="welcometext">
            and
            <span class="username username-hide-mobile" id="spanUsername"> Product</span> projects
          </p>
        </ng-container>
      </div>
    </div>

    <div *ngIf="hasPackagingAccess()">
      <piqet-angular-module-header
        [headerData]="headerDataForPackagingProject"
      ></piqet-angular-module-header>
      <div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12" *ngrxLet="sharedFacade.isClearSearch$ as isClearSearch">
              <piqet-angular-packaging-projects></piqet-angular-packaging-projects>
            </div>
            <hr class="hr" />
          </div>
        </div>
      </div>
    </div>

    <div class="page-container" *ngIf="hasProductAccess()">
      <div class="prod-projects-header">
        <piqet-angular-module-header
          [headerData]="headerDataForProductProject"
        ></piqet-angular-module-header>
        <span
          placement="auto"
          tooltipClass="sku-tooltip"
          class="product-project-tooltip"
          ngbTooltip="The product content module is now available as its own Product project.
                    You may create multiple Product projects to use within your Packaging projects."
        >
          <a class="info-icon">
            <span> <img src="./assets/icons/question-mark-icon.svg" width="16" height="16" /></span
          ></a>
        </span>
      </div>
      <app-feature-lock
        [isDisabled]="isCheckProductAccessDisabled"
        [featureCode]="FeatureCodes.PRODUCT_PROJECT"
      >
        <div class="container-fluid">
          <div
            class="row"
            id="targetDiv"
            [piqetAngularSectionAccess]="FeatureCodes.PRODUCT_PROJECT"
          >
            <piqet-angular-product-projects></piqet-angular-product-projects>
          </div>
        </div>
      </app-feature-lock>
    </div>
  </div>
</ng-container>

<ng-template #dashboard>
  <div class="portlet light" [ngClass]="{ 'responsive-height': isProjectTab }">
    <div class="portlet-title mt-80">
      <div class="caption caption-md">
        <span class="caption-subject">Recent projects</span>
      </div>
      <span
        joyrideStep="step3"
        *ngIf="showCreateAllData || joyrideService.isTourInProgress()"
        [text]="guideTourStep2Str"
        stepPosition="left"
        class="viewAll"
        (click)="selectAddNewProject()"
        ><span class="plusImageSvg"
          ><img src="./assets/icons/arrow-Group24.svg" height="40" width="35"
        /></span>
        <span class="newProjectButton"> New project</span></span
      >
      <span *ngIf="showViewAllData" class="viewAll mx-4"
        ><a routerLink="/projects" class="alltext theme-font">View all</a></span
      >
    </div>
    <div class="portlet-body">
      <ng-container *ngrxLet="sharedFacade.isLoaded$ as dataLoaded">
        <piqet-angular-ag-grid
          [columnDefs]="columnDefs"
          [frameworkComponents]="frameworkComponents"
          [gridData]="projectList"
          [class]="class"
          [hidePagination]="true"
          [gridName]="'Recent Projects'"
          [createAccess]="createAccess"
        ></piqet-angular-ag-grid>
      </ng-container>
    </div>
  </div>
</ng-template>
